import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";
import './AdminPanel.css'; // Import the CSS file containing overlay styles (adjust path if needed)

const AddBanner = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [userName, setUserName] = useState("");
  const [userFullName, setUserFullName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // To show error messages
  useEffect(() => {
    // Get user data from localStorage
    const storedUserType = localStorage.getItem("usertype");
    const storedUserName = localStorage.getItem("userName");
    const storedFName = localStorage.getItem("fname");
    const storedLName = localStorage.getItem("lname");

    console.log(storedUserType); // Log to ensure it's retrieved correctly
    if (!storedUserType) {
      navigate("/login"); // Redirect if not logged in
    } else {
      setUserType(storedUserType);
      setUserName(storedUserName);
      // Combine first and last name if available
      if (storedFName && storedLName) {
        setUserFullName(`${storedFName} ${storedLName}`);
      } else if (storedFName) {
        setUserFullName(storedFName);
      } else {
        setUserFullName(storedUserName);
      }
    }
  }, [navigate]);

  // Logout function
  const logout = () => {
    // Clear session data from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("userName");
    localStorage.removeItem("usertype");
    localStorage.removeItem("fname");
    localStorage.removeItem("lname");

    // Redirect to login page after logout
    navigate("/login");
  };

  const [formData, setFormData] = useState({
    name: "",
    mainImage: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFeatureChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      features: {
        ...formData.features,
        [name]: checked,
      },
    });
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log("Main image selected:", file); // Debugging log
      setFormData({
        ...formData,
        mainImage: file,
      });
    } else {
      console.log("No file selected");
    }
  };

  // const handleGalleryImageChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     galleryImages: Array.from(e.target.files),
  //   });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mainImage) {
      alert("Error: No main image uploaded or file error.");
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true); // Disable submit button and show overlay

    const data = new FormData();
    data.append("name", formData.name);
    data.append("main_image", formData.mainImage);

    // Append gallery images
    // formData.galleryImages.forEach((image) => {
    //   data.append("gallery_images[]", image);
    // });
    try {
      const response = await axios.post("https://api.mitradingjp.com/add_banner.php", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.success) {
        alert("Car details uploaded successfully!");
        // Reset form fields
        setFormData({
          name: "",
          mainImage: null,
          //galleryImages: [],
        });
        // Clear file input fields
        document.querySelector('input[name="mainImage"]').value = "";
        //document.querySelector('input[name="galleryImages"]').value = "";
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      console.error("There was an error uploading the data:", error);
      alert("There was an error uploading the data. Please try again.");
    } finally {
      setIsSubmitting(false); // Re-enable submit button and hide overlay
    }
  };

  return (
    <div className="admin-container">
      <div className="sidebar-container">
        {userType === "administrator" && <AdministratorSidebar />}
        {userType === "admin" && <AdminSidebar />}
        {userType === "user" && <UserSidebar />}
      </div>

      <div className="admin-content">
        <div className="adminnavbar">
          <h1>Welcome to the Admin Panel, {userFullName}</h1>
          {/* Logout button */}
          <button onClick={logout} className="logoutbtn">
            Logout
          </button>
          {/* Add the content of the admin panel here */}
        </div>

        <div className="mainsection">
          <h3>Add New Banner Picture</h3>
        </div>

        <form onSubmit={handleSubmit} className="p-4 border rounded">
      
          <div className="row mb-3">
            <div className="col-md-3">
              <input className="form-control" type="text" name="name" value={formData.name} onChange={handleChange} placeholder="name" />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Main Image:</label>
            <input
              type="file"
              name="mainImage"
              onChange={handleMainImageChange}
              className="form-control"
            />
          </div>

          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

          <button type="submit" disabled={isSubmitting} className="btn btn-primary">
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>

        {isSubmitting && (
          <div className="download-overlay">
            <div className="download-text">Wait till uploading the required Banner</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddBanner;